<ng-container >
  <ng-container >
   <app-bread-crumbs [lang]="lang" [routes]="nameRouting"></app-bread-crumbs>
 </ng-container>
 <div class="container mt-4">
   <div class="row categories-collection pb-4 mb-5"  *ngIf="allVendors?.length > 0">
     <div class="p-0" style="cursor: pointer "  *ngFor="let vendor of allVendors| paginate
     : {
           itemsPerPage: 20,
           currentPage: currentPage,
           totalItems: totalPage
       };
let i = index">
       <a
       style="margin: 0px auto !important"
       class="brand-item"
        [routerLink]="['/' + lang + '/products']"
        [queryParams]="{
          vendor_ids: vendor?.id
        }"
       >

   
       <!-- [routerLink]="['/' + lang + '/products']"
       (click)="rediectToProductPage(vendor)" -->

       <div class="imgContainer mx-2 radius-50 shadow'"
       >
           <img
               [src]="vendor.image"
               loading="lazy"  alt="{{ lang == 'en' ? vendor.name : vendor.name_ar }}"
               class="swiper-lazy radius-50 shadow"
               onError="this.src='./assets/images/placeholder200.jpg';"
               default="./assets/images/placeholder200.jpg"
               style="
               position: relative;
               top: 0px;
               left: 0px;
               margin-left: 0px;
               margin-right: 0px;
               object-fit: contain;
           "
           />
           <h3 class="text-center product-text my-3" style="color: var(--secoundry-color);">
             {{ lang == "en" ? vendor.name_en : vendor.name_ar }}
           </h3>
       </div>
   </a>
     </div>
   </div>
 </div>




 <div class="pagination">
  <pagination-controls
      class="product-pagination"
      (pageChange)="onPageChanged($event)"
      nextLabel="{{ 'button.next' | translate }}"
      previousLabel="{{ 'button.previous' | translate }}"
  >
  </pagination-controls>
</div>
</ng-container>


<!-- <h1>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa tempora minus aliquid esse autem corrupti quis molestias qui asperiores assumenda. Laborum delectus nulla qui deleniti dignissimos. Sunt temporibus aperiam fugiat.</h1> -->